import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76cee920"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("主要按钮")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("默认按钮")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("警告按钮")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("危险按钮")

import { useRouter } from 'vue-router'

import ReviewPeople from '@/components/review-people/ReviewPeople.vue'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const review = [
  {
    name: '尹鹏',
    img: 'https://img.yzcdn.cn/vant/cat.jpeg'
  },
  {
    name: '尹鹏1',
    img: 'https://img.yzcdn.cn/vant/cat.jpeg'
  },
  {
    name: '尹鹏2 ',
    img: 'https://img.yzcdn.cn/vant/cat.jpeg'
  }
]

const userInfo = ref({
  userName: ''
})

// userInfo.value = computed(() => store.getters['user/getUserInfo'])
// userInfo.value = store.state.user.userInfo

const navTitle = ref('')
navTitle.value = '首页'

const handleClick = () => {
  router.push('/home')
}

const tabBarChange = (val: any) => {
  tabIndex.value = val
}

const tabIndex = ref(0)
watch(tabIndex, (newValue, _) => {
  console.log(newValue)
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_base_tab_bar = _resolveComponent("base-tab-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: navTitle.value,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_button, {
      type: "primary",
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_van_button, { type: "success" }, {
      default: _withCtx(() => [
        _createTextVNode("成功按钮" + _toDisplayString(userInfo.value.userName), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_van_button, { type: "default" }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_van_button, { type: "warning" }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_van_button, { type: "danger" }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_common_info, { time: "2022-02-11" }),
    _createVNode(_component_base_tab_bar, { onChange: tabBarChange }),
    _createVNode(ReviewPeople, { review: review })
  ]))
}
}

})